import { render, staticRenderFns } from "./TopPaymentsChart.vue?vue&type=template&id=8e80843c&"
import script from "./TopPaymentsChart.vue?vue&type=script&lang=js&"
export * from "./TopPaymentsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports